import { fetchRequestWithTypes } from './index.js';

// Initiate distribution for user's specific IRA account.
// https://staging.stsh.io/documentation/1.0/ira_distributions/create.html

export const POST_IRA_DISTRIBUTION_REQUEST = 'POST_IRA_DISTRIBUTION_REQUEST';
export const POST_IRA_DISTRIBUTION_SUCCESS = 'POST_IRA_DISTRIBUTION_SUCCESS';
export const POST_IRA_DISTRIBUTION_ERRORED = 'POST_IRA_DISTRIBUTION_ERRORED';

export const postIraDistribution = (accountId, distribution) => {
	return fetchRequestWithTypes({
		types: [
			POST_IRA_DISTRIBUTION_REQUEST,
			POST_IRA_DISTRIBUTION_SUCCESS,
			POST_IRA_DISTRIBUTION_ERRORED,
		],
		request: {
			method: 'POST',
			path: `/apis/api/v1/users/:uuid/accounts/${accountId}/ira_distributions`,
			body: {
				distribution,
			},
		},
	});
};
